<template>
<div>
  <slot/>
</div>
</template>

<script lang="ts" setup>

import { watch} from 'vue';
import useForm from "@/composable/ui/useForm";

defineProps<{modelValue: boolean}>();
const emit = defineEmits<{(event: 'update:modelValue', value: boolean): void; }>();

const form = useForm();

watch(form.isValid, () => {
  emit('update:modelValue', form.isValid.value);
});

</script>

<style scoped>

</style>
